import { gql } from '@apollo/client';

export const DOCUMENT_UPLOADED = gql`
  subscription DocumentUploaded($documentId: Int!, $siteId: Int!) {
    documentUploaded(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      attachmentTypeId
      attachmentId
      contextId
      fileId
      userName
      uploadDate
      valabilityDate
      entityType
      entityTitle
    }
  }
`;

export const DOCUMENTS_NOT_UPLOADED = gql`
  subscription DocumentsNotUploaded($documentId: Int!, $siteId: Int!) {
    documentsNotUploaded(documentId: $documentId, siteId: $siteId) {
      documents
    }
  }
`;

export const DOCUMENT_ATTACHMENT_AND_PRINTS_GENERATED = gql`
  subscription AttachmentsAndPrintsGenerated($documentId: Int!, $siteId: Int!) {
    attachmentsAndPrintsGenerated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
    }
  }
`;

export const DOCUMENT_UPLOADED_WITH_STATE_UPDATE = gql`
  subscription DocumentUploadedWithStateUpdate($documentId: Int!, $siteId: Int!) {
    documentUploadedWithStateUpdate(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      attachmentTypeId
      attachmentId
      contextId
      fileId
      userName
      uploadDate
      valabilityDate
      stateId
      stateName
      stateColor
      canUpload
      canDelete
      canDeleteFile
      validatePropertiesOnUpload
    }
  }
`;

export const UPLOAD_DOCUMENTS_DATA_UPDATED = gql`
  subscription UploadDocumentsDataUpdated($documentId: Int!, $siteId: Int!) {
    uploadDocumentsDataUpdated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      list {
        oldAttachmentId
        newAttachmentId
        contextId
        stateId
        stateName
        stateColor
        fileId
        fileName
        isUploaded
        uploadDate
        valabilityDate
        userName
        isMandatory
        orderNo
        canExpire
        entityType
        entityTitle
        canDeleteFile
        attachmentProperties {
          attachmentId
          propertyId
          propertyName
          propertyValue
          propertyTypeCode
          propertyMandatory
          propertyVisible
          propertyReadOnly
        }
      }
    }
  }
`;

export const DOCUMENT_ATTACHMENT_STATE_CHANGED = gql`
  subscription DocumentAttachmentStateChanged($documentId: Int!, $siteId: Int!) {
    documentAttachmentStateChanged(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      documentAttachmentId
      stateId
      stateCode
      stateName
      stateColor
      reqDocTypeCode
      reqDocTypeName
      documentTypeCode
      documentStateCode
      canUpload
      canDelete
      canDeleteFile
      validatePropertiesOnUpload
    }
  }
`;

export const DOCUMENT_ATTACHMENT_DELETED = gql`
  subscription DocumentAttachmentDeleted($documentId: Int!, $siteId: Int!) {
    documentAttachmentDeleted(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      deletedAttachmentId
    }
  }
`;

export const DOCUMENT_ATTACHMENT_FILES_DELETED = gql`
  subscription DocumentAttachmentFilesDeleted($documentId: Int!, $siteId: Int!) {
    documentAttachmentFilesDeleted(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      fileId
      deletedLastVersion
    }
  }
`;

export const DOCUMENT_ATTACHMENT_UPDATED = gql`
  subscription AttachmentUpdated($documentId: Int!, $siteId: Int!, $attachmentId: Int!) {
    attachmentUpdated(documentId: $documentId, siteId: $siteId, attachmentId: $attachmentId) {
      documentId
      siteId
      documentAttachmentId
    }
  }
`;

export const DOCUMENT_HISTORY_FOUND = gql`
  subscription DocumentHistoryFound($fileId: String) {
    documentHistoryFound(fileId: $fileId) {
      fileId
      list {
        fileId
        exportedBy
        exportedDate
        sharepointFileName
        originalFileName
        version
        isDeleted
      }
    }
  }
`;

export const UPLOAD_DOCUMENT_LIST_EXECUTED = gql`
  subscription UploadDocumentListExecuted($documentId: Int!, $siteId: Int!) {
    uploadDocumentListExecuted(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      list {
        contextId
        attachmentId
        attachmentTypeName
        attachmentTypeId
        fileName
        valabilityDate
        verified
        comments
        contextName
        isUploaded
        fileId
        entityId
        entityTitle
        isMandatory
        uploadDate
        userName
        stateId
        stateName
        stateColor
        isExternal
        isDeleted
        canDownload
        canUpload
        canDelete
        validatePropertiesOnUpload
        orderNo
        uniqueId
        entityType
        canExpire
        canDeleteFile
        attachmentProperties {
          attachmentId
          propertyId
          propertyName
          propertyValue
          propertyTypeCode
          propertyMandatory
          propertyVisible
          propertyReadOnly
        }
        availableTransitions {
          flowId
          transitionId
          initialStateId
          initialStateName
          finalStateId
          finalStateName
          initialStateActiveProduct
          finalStateActiveProduct
          isInitialOrPostUploadTransition
        }
      }
    }
  }
`;

export const AVAILABLE_UPLOAD_DOCUMENT_LIST_EXECUTED = gql`
  subscription AvailableUploadDocumentListExecuted($documentId: Int!, $siteId: Int!) {
    availableUploadDocumentListExecuted(documentId: $documentId, siteId: $siteId) {
      list {
        contextId
        attachmentId
        attachmentTypeName
        attachmentTypeId
        fileName
        valabilityDate
        verified
        comments
        contextName
        isUploaded
        fileId
        entityId
        entityTitle
        isMandatory
        uploadDate
        userName
        stateId
        stateName
        stateColor
        isExternal
        isDeleted
        canDownload
        canUpload
        canDelete
        validatePropertiesOnUpload
        orderNo
        uniqueId
        entityType
        canExpire
        canDeleteFile
        attachmentProperties {
          attachmentId
          propertyId
          propertyName
          propertyValue
          propertyTypeCode
          propertyMandatory
          propertyVisible
          propertyReadOnly
        }
        availableTransitions {
          flowId
          transitionId
          initialStateId
          initialStateName
          finalStateId
          finalStateName
          initialStateActiveProduct
          finalStateActiveProduct
          isInitialOrPostUploadTransition
        }
      }
    }
  }
`;

export const EXPORT_DOCUMENT_LIST_EXECUTED = gql`
  subscription ExportDocumentListExecuted($documentId: Int!, $siteId: Int!, $userId: Int!) {
    exportDocumentListExecuted(documentId: $documentId, siteId: $siteId, userId: $userId) {
      documentId
      siteId
      list {
        documentPrintId
        templateName
        templateId
        fileId
        exportedBy
        exportedDate
        isUploaded
        needsSigning
        templateForSign
        signingStatus
        entityTitle
        signatureDate
        templateCode
        signatureTypeId
        documentTemplateXSignatures {
          documentTemplateId
          signatureId
          signatureName
          implicit
        }
        isSigningInProgress
      }
    }
  }
`;

export const EXPORT_DOCUMENT_EXECUTED = gql`
  subscription ExportDocumentExecuted($documentId: Int!, $siteId: Int!) {
    exportDocumentExecuted(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      filePath
      fileName
    }
  }
`;

export const PRINT_DOCUMENTS_EXECUTED = gql`
  subscription PrintDocumentsExecuted($documentId: Int!, $siteId: Int!) {
    printDocumentsExecuted(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      file {
        filePath
        fileName
      }
    }
  }
`;

export const DOCUMENTS_READY_FOR_SEND_EMAIL = gql`
  subscription DocumentsReadyForSendEmail($documentId: Int!, $siteId: Int!) {
    documentsReadyForSendEmail(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      filePath
      defaultEmail
    }
  }
`;

export const DOCUMENT_PRINT_SIGNING_RESET = gql`
  subscription DocumentPrintSigningReset($documentId: Int!, $siteId: Int!) {
    documentPrintSigningReset(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
    }
  }
`;

export const EXPORT_SIMULATION_EXECUTED = gql`
  subscription ExportSimulationExecuted($documentId: Int!, $siteId: Int!, $simulationId: Int!) {
    exportSimulationExecuted(documentId: $documentId, siteId: $siteId, simulationId: $simulationId) {
      documentId
      siteId
      simulationId
      filePath
      fileName
    }
  }
`;

export const EXPORT_DOCUMENT_LIST_UPDATED = gql`
  subscription ExportDocumentListUpdated($documentId: Int!, $siteId: Int!) {
    exportDocumentListUpdated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      documentPrintList {
        documentPrintId
        signingStatus
        fileId
        exportedBy
        exportedDate
        isUploaded
        needsSigning
        isSigningInProgress
      }
    }
  }
`;

export const ALL_UPLOAD_DOCUMENT_LIST_EXECUTED = gql`
  subscription AllUploadDocumentListExecuted($documentId: Int!, $siteId: Int!) {
    allUploadDocumentListExecuted(documentId: $documentId, siteId: $siteId) {
      attachmentId
      attachmentName
      attachmentTypeId
      contextId
      entityTitle
    }
  }
`;

export const UPLOAD_DOCUMENT_EXECUTED = gql`
  subscription UploadDocumentExecuted($documentId: Int!, $siteId: Int!) {
    uploadDocumentExecuted(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      newDocument {
        contextId
        attachmentId
        attachmentTypeName
        attachmentTypeId
        fileName
        valabilityDate
        verified
        comments
        contextName
        isUploaded
        fileId
        entityId
        entityTitle
        isMandatory
        uploadDate
        userName
        stateId
        stateName
        stateColor
        isExternal
        isDeleted
        canDownload
        canUpload
        canDelete
        validatePropertiesOnUpload
        orderNo
        uniqueId
        entityType
        canExpire
        attachmentProperties {
          attachmentId
          propertyId
          propertyName
          propertyValue
          propertyTypeCode
          propertyMandatory
          propertyVisible
          propertyReadOnly
        }
        availableTransitions {
          flowId
          transitionId
          initialStateId
          initialStateName
          finalStateId
          finalStateName
          initialStateActiveProduct
          finalStateActiveProduct
          isInitialOrPostUploadTransition
        }
      }
    }
  }
`;
export const OFFER_STATE_UPDATED = gql`
  subscription offerStateUpdated($documentId: Int!, $siteId: Int!) {
    offerStateUpdated(documentId: $documentId, siteId: $siteId) {
      documentId
      siteId
      stateId
      stateCode
      stateName
      offerNo
      documentTypeCode
      folderStateCode
      folderTypeId
      userId
    }
  }
`;
